import React, {useEffect, useRef, useState} from 'react';
import {useNavigation, useIsFocused} from '@react-navigation/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {AppEventsLogger} from 'react-native-fbsdk-next';
import {RefreshControl} from 'react-native';
import ReactNativeHapticFeedback, {
  HapticFeedbackTypes,
} from 'react-native-haptic-feedback';

import {ProfileHeader} from '../../components/Interface/Headers/ProfileHeader';

import {api} from '../../services/api';

import analytics from '@react-native-firebase/analytics';

import {
  Container,
  SelectProductCategoryContainer,
  Row,
  ProductCategoryItem,
  ProductCategoryImage,
  ProductTypeName,
  ProductMask,
  ProductCategoryInfos,
} from './styles';

import {useAuth} from '../../context/auth';

import {RatingModal} from '../../components/shared/RatingModal';
import {CategoryShimmer} from '../../components/Interface/Loadings/CategoryShimmer';
import {NotFound} from '../../components/Interface/Search/NotFound';

import {useLocalization} from '../../context/localization';
import {rastrear} from '../../services/rastrear';
import {Step} from '../../components/Interface/Step';
import {ScreenTitle} from '../../components/shared/ScreenTitle';

import {
  HeaderIconButton,
  HeaderIconButtonsRow,
} from '../../components/Interface/Headers/HeaderIconButton';
//import {useTutorial} from '../../context/TutorialProvider';

interface IProductTypes {
  nome: string;
  codigo: string;
  ordem: number;
  image_url: string;
  image_url2: string;
}

export function Shopping() {
  const {user, isLogged, openSign} = useAuth();

  const navigation = useNavigation();

  const screenIsFocus = useIsFocused();
  const {locationIsActive} = useLocalization();

  const [productTypes, setProductTypes] = useState<IProductTypes[]>(
    [] as IProductTypes[],
  );

  //const {endTutorial} = useTutorial();

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  async function fetchProductImages(isRefresh = false) {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    try {
      const response = await api.post('/tipoProduto');
      if (response.data) {
        setProductTypes(response.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (isRefresh) {
        setRefreshing(false);
      } else {
        setLoading(false);
      }
    }
  }
  const hasCalled = useRef(false);

  function handleCategory(tipo: string) {
    analytics().logEvent('clica_card_tipo_' + tipo);

    if (tipo === 'B') {
      if (isLogged) {
        return navigation.navigate('SearchBoleto', {tipo: 'bancario'});
      } else {
        return openSign();
      }
    }

    if (tipo === 'M') {
      if (isLogged) {
        return navigation.navigate('VehicleDebits');
      } else {
        return openSign();
      }
    }

    if (locationIsActive) {
      navigation.navigate('ListagemPostos', {
        isUserLocation: true,
        tipo,
      });
    } else {
      navigation.navigate('Localization', {
        tipo,
      });
    }
  }

  useEffect(() => {
    fetchProductImages();
  }, [screenIsFocus]);

  useEffect(() => {
    AppEventsLogger.logEvent('abre_lista_de_categoria');
  }, []);

  useEffect(() => {
    if (!screenIsFocus) {
      hasCalled.current = false;
      return;
    }
    if (hasCalled.current) {return;}
    hasCalled.current = true;
    rastrear({status_tela: 'shopping'});
  }, [screenIsFocus]);

  return (
    <>
      <ProfileHeader />

      <Container>
        {!loading && productTypes.length <= 0 ? (
          <NotFound
            title="Ocorreu um problema"
            style={{}}
            text="Não foi possível listar as categorias de produtos."
          />
        ) : (
          <SelectProductCategoryContainer
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: RFValue(120),
            }}
            refreshControl={
              <RefreshControl
                refreshing={false}
                onRefresh={() => {
                  ReactNativeHapticFeedback.trigger(
                    HapticFeedbackTypes.impactMedium,
                    {enableVibrateFallback: false},
                  );
                  fetchProductImages(true);
                }}
                tintColor="#17B70F"
                colors={['#17B70F']}
              />
            }>
            <ScreenTitle
              title="O que deseja para hoje?"
              rightContent={
                <HeaderIconButtonsRow>
                  <HeaderIconButton
                    icon="refresh"
                    onPress={() => fetchProductImages(true)}
                  />
                </HeaderIconButtonsRow>
              }
            />

            {!loading && !refreshing ? (
              productTypes.length > 0 &&
              productTypes
                .sort((a, b) => a.ordem - b.ordem)
                .map((categoria, index) => {
                  if (index === 0 || index === 1 || index === 2) {
                    return index === 0 ? (
                      <Step
                        order={4}
                        contextName="welcome"
                        text="Clique aqui para comprar combustível!"
                        key={index}
                        topInset={RFValue(6)}
                        screen="Shopping"
                        onPress={() => {
                          navigation.navigate('Localization', {
                            tipo: 'C',
                          });
                        }}>
                        <Row>
                          <ProductCategoryItem
                            activeOpacity={1}
                            onPress={() => handleCategory(categoria.codigo)}
                            style={{
                              width: '100%',
                            }}>
                            <ProductMask />
                            <ProductCategoryImage
                              source={{uri: categoria.image_url2}}
                            />
                            <ProductCategoryInfos>
                              <ProductTypeName>
                                {categoria.nome}
                              </ProductTypeName>
                            </ProductCategoryInfos>
                          </ProductCategoryItem>
                        </Row>
                      </Step>
                    ) : (
                      <Row key={index}>
                        <ProductCategoryItem
                          activeOpacity={1}
                          onPress={() => handleCategory(categoria.codigo)}
                          style={{
                            width: '100%',
                          }}>
                          <ProductMask />
                          <ProductCategoryImage
                            source={{uri: categoria.image_url2}}
                          />
                          <ProductCategoryInfos>
                            <ProductTypeName>{categoria.nome}</ProductTypeName>
                          </ProductCategoryInfos>
                        </ProductCategoryItem>
                      </Row>
                    );
                  } else if ((index - 1) % 2 === 0) {
                    return (
                      <Row key={index}>
                        <ProductCategoryItem
                          activeOpacity={1}
                          onPress={() => handleCategory(categoria.codigo)}
                          style={{
                            paddingRight: RFValue(6),
                          }}>
                          <ProductMask />
                          <ProductCategoryImage
                            source={{uri: categoria.image_url2}}
                          />
                          <ProductCategoryInfos>
                            <ProductTypeName>{categoria.nome}</ProductTypeName>
                          </ProductCategoryInfos>
                        </ProductCategoryItem>

                        {index + 1 < productTypes.length && (
                          <ProductCategoryItem
                            activeOpacity={1}
                            onPress={() =>
                              handleCategory(productTypes[index + 1].codigo)
                            }
                            style={{
                              paddingLeft: RFValue(3),
                            }}>
                            <ProductMask style={{right: 0}} />
                            <ProductCategoryImage
                              source={{uri: productTypes[index + 1].image_url2}}
                            />
                            <ProductCategoryInfos
                              style={{marginLeft: RFValue(12)}}>
                              <ProductTypeName>
                                {productTypes[index + 1].nome}
                              </ProductTypeName>
                            </ProductCategoryInfos>
                          </ProductCategoryItem>
                        )}
                      </Row>
                    );
                  }
                  return null;
                })
            ) : (
              <CategoryShimmer />
            )}
          </SelectProductCategoryContainer>
        )}

        {user.user_id !== 'convidado' && <RatingModal />}
      </Container>
    </>
  );
}
